// extracted by mini-css-extract-plugin
export default {"icon":"Spinner_icon__hLlRR","rotate":"Spinner_rotate__H2OBE","primary":"Spinner_primary__cMz0W","secondary":"Spinner_secondary__QKn+2","center":"Spinner_center__JO-Pb"};